import { render, staticRenderFns } from "./shippingMethods.vue?vue&type=template&id=5ee27bc3"
import script from "./shippingMethods.vue?vue&type=script&lang=js"
export * from "./shippingMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports